export function unsubscribeAll(...unsubscribers) {
  return () => unsubscribers.forEach(unsubscribe => unsubscribe());
}